import { appConfigMeta, filterLocalStorageConfigs, filterServerOnlyConfigs } from '@a1/shared';

const replaceObjectValues = (obj) => {
  // this function will iterate through the appConfig object and return only the 'value' field, setting as the new value (replacing the object that contained the 'value' field).
  // i.e., generalSettings.sendBySmsEnabled: { value: false, title: 'Sending by SMS', description: "Allows SMS", type: AppConfigTypes.BOOLEAN },
  // will become `generalSettings.sendBySmsEnabled: false`
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if ('value' in obj) {
    return obj.value;
  }

  const newObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      if (typeof value === 'object' && value !== null) {
        newObj[key] = replaceObjectValues(value);
      } else {
        newObj[key] = value;
      }
    }
  }

  return newObj;
};

const defaultAppConfig = replaceObjectValues(filterServerOnlyConfigs(filterLocalStorageConfigs(appConfigMeta)));

export default defaultAppConfig;
